import React from 'react';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-32 overflow-hidden" data-id="element-185">
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-186">
        {/* Urgency reminder */}
        <div className="inline-flex items-center gap-2 px-6 py-3 bg-orange-500/20 border border-orange-500/40 rounded-full mb-8" data-id="element-187">
          <span className="text-lg font-semibold text-orange-300" data-id="element-188">
            ⚡ Only 8 Spots Remaining for March 15-18 Cohort
          </span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-189">
          48 Hours in Cancun.
          <br data-id="element-190" />
          <span className="bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent" data-id="element-191">
            Years of AI Advantage.
          </span>
        </h2>

        <p className="text-2xl text-slate-300 mb-8 max-w-3xl mx-auto" data-id="element-192">
          If you feel like you're behind on AI, this is where you catch up—and
          leap ahead.
        </p>

        {/* Value props */}
        <div className="flex flex-wrap justify-center gap-6 mb-12 text-slate-300" data-id="element-193">
          <div className="flex items-center gap-2" data-id="element-194">
            <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-195" />
            <span data-id="element-196">90-day action plan</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-197">
            <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-198" />
            <span data-id="element-199">Working prototypes</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-200">
            <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-201" />
            <span data-id="element-202">Board-ready strategy</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-203">
            <CheckCircleIcon className="w-5 h-5 text-green-400" data-id="element-204" />
            <span data-id="element-205">60-day guarantee</span>
          </div>
        </div>

        <button className="group px-10 py-5 bg-gradient-to-r from-cyan-500 to-purple-500 text-white text-lg font-semibold rounded-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all duration-300 flex items-center gap-3 mx-auto mb-8" data-id="element-206">
          Secure Your Spot - Apply Now
          <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-207" />
        </button>

        <p className="text-slate-400 text-sm max-w-2xl mx-auto mb-8" data-id="element-208">
          One cohort per month. Limited to 24 participants. Priority for teams
          and companies ready to act.
        </p>

        <p className="text-slate-500 text-xs" data-id="element-209">
          No credit card required to apply • 15-minute interview process •
          Response within 24 hours
        </p>

        {/* Footer info */}
        <div className="mt-16 pt-8 border-t border-slate-800" data-id="element-210">
          <div className="flex flex-wrap justify-center gap-8 text-sm text-slate-500" data-id="element-211">
            <span data-id="element-212">World-Class Faculty</span>
            <span data-id="element-213">•</span>
            <span data-id="element-214">Enterprise AI Tools</span>
            <span data-id="element-215">•</span>
            <span data-id="element-216">Beachside Innovation</span>
            <span data-id="element-217">•</span>
            <span data-id="element-218">500+ Leaders Transformed</span>
          </div>
        </div>
      </div>
    </section>;
}